import map from 'lodash/map';
import type { ICitiesTariffs } from '~/src/services/api/api-content/cities/tariffs';
import type {
    IBundlePackage,
    IInternetPackage,
    ISalePackageLink,
    ISalePackageSubscription,
} from '~/src/services/api/api-content/cities/types';

export type TUnpreparedTariffs = {
    bundles: Record<string, IBundlePackage>,
    mono: IInternetPackage[],
}

export const prepareData = ({ mono, bundles }: TUnpreparedTariffs): ICitiesTariffs => {
    return {
        mono,
        bundles: map(bundles, item => item),
    };
};

export const unifySubscriptionItems = (salePackageeLinks: ISalePackageLink[]): ISalePackageSubscription[] => {
    return salePackageeLinks.reduce((acc: ISalePackageSubscription[], item) => {
    item.subscriptions?.length && item.subscriptions.forEach(subscription => {
        const subsIndex = acc.findIndex(el => el.id === subscription.id);
        if (subsIndex === -1) {
            acc.push(subscription);
        }
    });
    return acc;
}, []);
};
